import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import { AuthService } from '@core/services/auth.service';
import { BusLookupService } from '@core/services/bus-lookup.service';
import { NotifyService } from '@core/services/notify.service';
import { ValidationService } from '@shared/services/validation.service';
import { TicketScheduleService } from '../../services/ticket-schedule.service';
import { TicketsService } from '../../services/tickets.service';
import { AppUtilService } from '@shared/services/app-util.service';
import { ConvertDateUtcTimezoneService } from '@shared/services/convert-date-utc-timezone.service';
import { BusinessLookup, WeekDays } from '@generated/queries';
import { busLookups, busLookupsModuleCode, FrequencyCode } from '@core/enums/bus-Lookup';
import { PageFilter } from '@core/model/pagination/filter';
import { take } from 'rxjs';
import { TicketSchedule } from '../../models/ticket-schedule';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import moment from 'moment';
import { plainToInstance } from 'class-transformer';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';
import { BkButton } from '@brickclay-org/ui';
type Tabs = 'Weekly' | 'Monthly'| 'Yearly';
@Component({
  selector: 'app-ticket-schedule',
  imports:[CommonModule, NgxDaterangepickerMd,BkButton,MatTooltip, MatDialogModule,  // ✅ Required for mat-dialog-close
    MatTooltipModule ,FormsModule, ReactiveFormsModule, NgSelectModule],
  templateUrl: './ticket-schedule.component.html',
  styleUrl: './ticket-schedule.component.css',
})
export class TicketScheduleComponent implements OnInit {
  isMonthly = false;
  isWeekly = false;
  isYearly = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  startDate: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  endDate: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  scheduleYearDate:any;
  //
  businessId:string;
  businessTicketSchedule: BusinessLookup[];
  timeZone:string;
  /** Facility timezone from the ticket - used for schedule date conversions */
  facilityTimeZone: string | undefined;
  form: FormGroup;
   busLookupSchedule = busLookupsModuleCode.TicketSchedule;
  busLookupModuleCode = busLookupsModuleCode;
  scheduleStatus: BusinessLookup[];
  scheduleNotificationStatus: BusinessLookup[];
  filters: PageFilter = {
      pageIndex: 0,
      activeIndex: 1,
      take: 25,
      search: '',
      state: '',
    };
  workingDays: number[] = [];
  weekOptions: { label: string, value: number }[] = [];
  monthOptions: { label: string, value: number }[] = [];
  selectedOption = 1; // Default selection
  selectedOptionEvery: number; // Default selection
  ticketSchedule: TicketSchedule;
  isChangeAnything = false;
  lookupCode =  busLookups;
  frequencyCode = FrequencyCode.WEEKLY;
  selectedScheduleStatusId:string;
  selectedScheduleNotifyId:string;
  formattedDate = '';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @ViewChild('picker') picker: any;
  selectedTicketId:string;
  loading=false;
  interval = 0;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  scheduleData: any = null;
  selectedYearlyDate: Date | null = null;  // Use native Date object for ngx-daterangepicker
  dateLocale = {
    format: 'MM/DD/YYYY',  // → e.g., May 2, 2025
  };
  isSaveButtonDisable = true;
  /** Snapshot of form value when dialog opens with existing schedule; used to disable Submit when form reverts to initial state */
  private initialFormSnapshot: string | null = null;
  constructor(
    private dialogRef: MatDialogRef<TicketScheduleComponent>,
        public validationService: ValidationService,
        private notifyService: NotifyService,
        public busService: BusLookupService,
        private fb: FormBuilder,
        private elementRef: ElementRef,
        private authService:AuthService,
        private service: TicketScheduleService,
        public ticketService: TicketsService,
        private appUtilService: AppUtilService,
        public convertUtcToTimeZone: ConvertDateUtcTimezoneService,
  ) {
    let tz = this.ticketService.timeZone;
    if (!tz) {
      const stored = localStorage.getItem('timeZones');
      if (stored) {
        try {
          const parsed = JSON.parse(stored);
          tz = Array.isArray(parsed) ? parsed[0] : parsed;
        } catch {
          tz = stored;
        }
      }
    }
    this.timeZone = tz || 'UTC+00:00';
    this.selectedTicketId = this.ticketService.selectedTicketId;
    this.initForm();

    // Manually listen for ESC key inside this dialog
    this.dialogRef.keydownEvents().subscribe((event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        this.cancel(); // only closes this dialog
      }
    });
  }

  activeTab: Tabs = 'Weekly';
  setTab(tab: Tabs) {
    this.activeTab = tab;
    if(tab == 'Weekly'){
      this.frequencyCode = FrequencyCode.WEEKLY;
      this.isWeekly=true;
    }
    else if(tab == 'Monthly'){
      this.frequencyCode = FrequencyCode.MONTHLY;
      this.isMonthly = true;
    }
    else if(tab == 'Yearly'){
      this.frequencyCode = FrequencyCode.YEARLY;
      this.isYearly = true;
    }
    this.onChangeFrequency();
  }
  activeClass(tab: Tabs) {
    return tab === this.activeTab ? 'bg-white text-[#15191E] border-[#E3E6EE]' : 'border-transparent';
  }

  weekDays: WeekDays[] = [
    WeekDays.Sunday,
    WeekDays.Monday,
    WeekDays.Tuesday,
    WeekDays.Wednesday,
    WeekDays.Thursday,
    WeekDays.Friday,
    WeekDays.Saturday,
  ];
  cancel() {
    this.dialogRef.close();
  }

  async ngOnInit(){
    this.businessId = this.authService.businessId;
    await this.busService.fetchBussinessLookupByCodeActAllChild(true,this.busLookupSchedule);
    this.scheduleStatus = (await this.busService.paginatedBussinessLookupOnlyChild(this.filters,this.busLookupModuleCode.TicketScheduleStatus))['items'];
    this.scheduleNotificationStatus = (await this.busService.paginatedBussinessLookupOnlyChild(this.filters,this.busLookupModuleCode.TicketScheduleNotifyStatus))['items'];
    this.busService.BusLookupSchedule$.pipe(take(1)).subscribe(result => {
      if (result && result?.data?.length > 0) {
        this.businessTicketSchedule = result?.data;
        this.isWeekly = true;

      }

      // Run initForm only after data is available
      this.getData().then(async () =>
        await this.initForm());

    });
  }

  private parseDateSafe(dateStr?: string, format = 'M/D/YYYY h:mm:ss A') {
  return dateStr ? moment(dateStr, format, true) : null;
}

  private getScheduleTime(): string | null {
  if (!this.ticketSchedule?.ticketScheduleDateTime) return null;

  const tz = this.facilityTimeZone || this.timeZone;
  const converted = this.convertUtcToTimeZone.convertUTCToLocalTime(
    this.ticketSchedule.ticketScheduleDateTime,
    tz
  );
  const parsed = this.parseDate(converted.replace(',', '')).toTimeString();
  return parsed?.length > 5 ? parsed.substring(0, 5) : null;
}

  private getScheduleTimeTo(): string | null {
  if (!this.ticketSchedule?.ticketScheduleEndDate) return null;

  const tz = this.facilityTimeZone || this.timeZone;
  const converted = this.convertUtcToTimeZone.convertUTCToLocalTime(
    this.ticketSchedule.ticketScheduleEndDate,
    tz
  );
  if (!converted) return null;
  try {
    const parsed = this.parseDate(converted.replace(',', '')).toTimeString();
    return parsed?.length > 5 ? parsed.substring(0, 5) : null;
  } catch {
    return null;
  }
}

private getValidMoment(date: moment.Moment | null) {
  return date?.isValid()
    ? { startDate: date, endDate: date }
    : null;
}

initForm() {
  // Resolve schedule details first so Yearly has selectedYearlyDate set before we build the form
  if (this.ticketSchedule) {
    this.getScheduleDetails(this.ticketSchedule.ticketScheduleSetting);
  }

  const scheduleTime = this.getScheduleTime();
  const scheduleTimeTo = this.getScheduleTimeTo();

  let parsedStartDate = this.parseDateSafe(this.ticketSchedule?.ticketScheduleStartDate?.toString());
  let parsedEndDate = this.parseDateSafe(this.ticketSchedule?.ticketScheduleEndDate?.toString());
  const parsedYearDate = this.isYearly && this.selectedYearlyDate
    ? moment(this.selectedYearlyDate)
    : null;

  parsedStartDate ??= this.parseDateSafe(new Date().toString());
  parsedEndDate ??= this.parseDateSafe(new Date().toString());

  this.form = this.fb.group({
    id: [this.ticketSchedule?.id],
    businessId: [this.businessId],
    ticketId: [this.selectedTicketId, Validators.required],
    frequencyId: [this.ticketSchedule?.frequencyId, Validators.required],
    ticketScheduleDateTime: [this.ticketSchedule?.ticketScheduleDateTime],
    scheduleTime: [scheduleTime, Validators.required],
    scheduleTimeTo: [scheduleTimeTo ?? null, Validators.required],
    interval: [this.interval > 0 ? this.interval : [], Validators.required],
    daysOfWeek: [this.isWeekly ? this.scheduleData : null],
    dayOfMonth: [this.isMonthly ? this.scheduleData : null],
    dayOfYear: [this.isYearly ? this.getValidMoment(parsedYearDate) : null],
    ticketScheduleSetting: [this.ticketSchedule?.ticketScheduleSetting],
    ticketScheduleStartDate: [this.getValidMoment(parsedStartDate)],
    ticketScheduleEndDate: [this.getValidMoment(parsedEndDate)],
    ticketScheduleStatusId: [this.ticketSchedule?.ticketScheduleStatusId, Validators.required],
    ticketScheduleNotificationStatusId: [this.ticketSchedule?.ticketScheduleNotificationStatusId, Validators.required],
  });

  this.form.valueChanges.subscribe(() => {
    if (!this.form.get('frequencyId')?.value) {
      const settings = this.businessTicketSchedule.find(y => y.code === this.frequencyCode);
      this.form.get('frequencyId')?.setValue(settings?.id);
    }
    this.updateSaveButtonDisabled();
  });

  // When editing existing schedule, start with button disabled until form is dirty
  if (this.ticketSchedule?.id) {
    this.initialFormSnapshot = this.getFormSnapshot();
    this.isSaveButtonDisable = true;
  } else {
    this.initialFormSnapshot = null;
    this.isSaveButtonDisable = false;
  }
}

  /** Serialize form value for comparison; when equal to initial snapshot, Schedule Ticket should be disabled */
  private getFormSnapshot(): string {
    const v = this.form?.getRawValue();
    if (!v) return '';
    const start = v.ticketScheduleStartDate?.startDate ? moment(v.ticketScheduleStartDate.startDate).format('YYYY-MM-DD') : '';
    const end = v.ticketScheduleEndDate?.startDate ? moment(v.ticketScheduleEndDate.startDate).format('YYYY-MM-DD') : '';
    const dayOfYear = v.dayOfYear?.startDate ? moment(v.dayOfYear.startDate).format('YYYY-MM-DD') : '';
    return JSON.stringify({
      frequencyId: v.frequencyId,
      interval: v.interval,
      daysOfWeek: (v.daysOfWeek ?? []).slice().sort((a: number, b: number) => a - b),
      dayOfMonth: v.dayOfMonth ?? null,
      dayOfYear,
      startDate: start,
      endDate: end,
      scheduleTime: v.scheduleTime ?? '',
      scheduleTimeTo: v.scheduleTimeTo ?? '',
      ticketScheduleStatusId: v.ticketScheduleStatusId ?? '',
      ticketScheduleNotificationStatusId: v.ticketScheduleNotificationStatusId ?? '',
    });
  }

  private updateSaveButtonDisabled(): void {
    if (this.initialFormSnapshot == null) {
      this.isSaveButtonDisable = false;
      return;
    }
    this.isSaveButtonDisable = this.getFormSnapshot() === this.initialFormSnapshot;
  }

  parseDate(dateStr: string): Date {
      const [datePart, timePart, ampm] = dateStr.split(" ");
      const [month, day, year] = datePart.split("/").map(Number);
      const [hour, minute, second] = timePart.split(":").map(Number);

      // Adjust hour for AM/PM format
      let hour24 = hour;
      if (ampm === "PM" && hour !== 12) {
        hour24 += 12;
      } else if (ampm === "AM" && hour === 12) {
        hour24 = 0;
      }

      // Create and return the Date object
      return new Date(year, month - 1, day, hour24, minute, second);
    }
    isSelected(day: WeekDays) {
    const index = this.weekDays.indexOf(day);
    return this.workingDays.includes(index);
  }
  toggleWorkingDay(value: WeekDays) {
      if (this.workingDays.some((x) => x === this.weekDays.findIndex(x => x === value)))
        this.workingDays = this.workingDays.filter(
          (x) => x !== this.weekDays.findIndex(x => x === value)
        );
      else {
        this.workingDays.push(this.weekDays.findIndex(x => x === value));
      }
      this.updateRepeatToggleBasedOnWorkingDays();
      this.updateSaveButtonDisabled();
      this.form.markAsDirty();
    }

    updateRepeatToggleBasedOnWorkingDays() {
      const control = this.form.get('isRepeatForFuture');
      if (this.workingDays.length < 7) {
        control?.setValue(false);
        control?.disable(); // Optional: disable to make it unclickable
      } else {
        control?.enable();  // Optional: re-enable if conditions met
        //control?.setValue(this.ticketSchedule?.isRepeatForFuture ?? true);
      }
    }

    onSelectionChange() {
    this.isChangeAnything = true;
    this.updateSaveButtonDisabled();
  }

  onSelectionChangeEvery() {
    this.isChangeAnything = true;
    this.updateSaveButtonDisabled();
  }

  Recursion(settings: number[], freqvalue: string) {
    this.weekOptions = []; // Reset options

    settings.forEach((freq) => {
      const label = freq === 1 ? 'Every ' + freqvalue : `${freq} ${freqvalue}s`;
      this.weekOptions.push({ label, value: freq });
    });
  }

  async getData(){
      this.ticketSchedule = await this.service.getTicketScheduleByTicketId(this.selectedTicketId,'network-only');
      try {
        const ticket = await this.ticketService.getTickets(this.selectedTicketId);
        this.facilityTimeZone = ticket?.facility?.timeZone;
      } catch {
        this.facilityTimeZone = undefined;
      }
      if(!this.ticketSchedule){
        this.frequencyCode = FrequencyCode.WEEKLY;
        this.setTab('Weekly');
        return;
      }
      const data = JSON.parse(this.ticketSchedule?.ticketScheduleSetting);
      if (data?.Weekly) {
        this.frequencyCode = FrequencyCode.WEEKLY;
        this.setTab('Weekly');
      }
      else if(data?.Monthly){
        this.frequencyCode = FrequencyCode.MONTHLY;
        this.setTab('Monthly');
      }
      else if(data?.Yearly){
        this.frequencyCode = FrequencyCode.YEARLY;
        this.setTab('Yearly');
      }
      await this.onChangeFrequency();
    }
    /** Parse stored "MMM, D" (e.g. "Jun, 24") to a Date. Uses schedule start date year when available so the recursion date is in the same range as start/end; otherwise current year. */
    convertStringToDate(dateString: string, scheduleStartDate?: Date | string | null): Date {
      let year = new Date().getFullYear();
      if (scheduleStartDate != null) {
        const d = typeof scheduleStartDate === 'string' ? new Date(scheduleStartDate) : scheduleStartDate;
        if (!isNaN(d.getTime())) year = d.getFullYear();
      }
      const formattedString = `${dateString}, ${year}`;
      return moment(formattedString, "MMM, D, YYYY").toDate();
    }

  getScheduleDetails(jsonFrequency: string): { type: string, interval: number, scheduleData: string } | null {

      let type = "";
      let interval = 0;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      let scheduleData: any = null;
      const data = JSON.parse(jsonFrequency);
      this.isWeekly = false;
      this.isMonthly = false;
      this.isYearly = false;
      if (data.Weekly) {
          type = "Weekly";
          this.isWeekly = true;
          this.interval = data.Weekly.Interval;
          this.scheduleData = data.Weekly.DaysOfWeek;
          interval = data.Weekly.Interval;
          scheduleData= data.Weekly.DaysOfWeek;
          this.workingDays = scheduleData;
          const settings = this.businessTicketSchedule.find(y => y.code == this.lookupCode.WeeklySchedule);
          // Ensure settings.setting is parsed as an array
          let parsedSettings: number[] = [];
          parsedSettings = JSON.parse(settings.setting);
          this.Recursion(parsedSettings, 'Week');
      } else if (data.Monthly) {
          type = "Monthly";
          this.isMonthly = true;
          this.interval = data.Monthly.Interval;
          this.scheduleData = data.Monthly.DayOfMonth;
          interval = data.Monthly.Interval;
          scheduleData= data.Monthly.DayOfMonth;

          const settings = this.businessTicketSchedule.find(y => y.code == this.lookupCode.MonthlySchedule);
          // Ensure settings.setting is parsed as an array
          let parsedSettings: number[] = [];
          parsedSettings = JSON.parse(settings.setting);
          this.Recursion(parsedSettings, 'Month');
          this.monthDateRecursion();
      } else if (data.Yearly) {
          type = "Yearly";
          this.isYearly = true;
          this.interval = data.Yearly.Interval;
          this.scheduleData = data.Yearly.DayOfYear;
          interval = data.Yearly.Interval;
          scheduleData= data.Yearly.DayOfYear;

          const settings = this.businessTicketSchedule.find(y => y.code == this.lookupCode.YearlySchedule);
          // Ensure settings.setting is parsed as an array
          let parsedSettings: number[] = [];
          parsedSettings = JSON.parse(settings.setting);
          this.Recursion(parsedSettings, 'Year');
          this.selectedYearlyDate = this.convertStringToDate(scheduleData, this.ticketSchedule?.ticketScheduleStartDate);
          this.formattedDate = scheduleData;
      }

      if (type) {
        return { type, interval, scheduleData };
      }
      return null; // If none exist

  }

  monthDateRecursion() {
    this.monthOptions = []; // Reset options

    for (let i = 1; i <= 31; i++) {
      const label = `${i}${this.nthSuffix(i)}`;
      this.monthOptions.push({ label, value: i });
    }
  }

  nthSuffix(day: number): string {
    if (day >= 11 && day <= 13) return "th"; // Handle 11th, 12th, 13th
    switch (day % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  }
  onChangeFrequency(){
      this.isMonthly = false;
      this.isWeekly = false;
      this.isYearly = false;
      this.isChangeAnything = true;
      // });
      const settings = this.businessTicketSchedule.find(y => y.code == this.frequencyCode);
      this.form?.get('frequencyId')?.setValue(settings.id);
        // Ensure settings.setting is parsed as an array
      let parsedSettings: number[] = [];

      if (settings && typeof settings.setting === 'string') {
        try {
          parsedSettings = JSON.parse(settings.setting); // Convert JSON string to an array
        } catch (error) {
          console.error("Invalid JSON format in settings.setting", error);
        }
      }
      if(settings.code == this.lookupCode.WeeklySchedule)
      {
        this.isWeekly = true;
        this.Recursion(parsedSettings, 'Week');

      }
      else if(settings.code == this.lookupCode.MonthlySchedule)
      {
        this.isMonthly = true;
        this.monthDateRecursion();
        this.Recursion(parsedSettings, 'Month');
      }
      else if(settings.code == this.lookupCode.YearlySchedule)
      {
        this.isYearly = true;
        this.Recursion(parsedSettings, 'Year');
      }
      this.toggleValidatorsBasedOnWeekly();
      this.toggleValidatorsBasedOnMonthly();
      this.toggleValidatorsBasedOnYearly();
    }

    toggleValidatorsBasedOnWeekly() {
    const control = this.form.get('daysOfWeek');
    if (!this.isWeekly) {
      control?.clearValidators();
    }
    control?.updateValueAndValidity();
  }

  toggleValidatorsBasedOnMonthly() {
    const control = this.form.get('dayOfMonth');
    if (!this.isMonthly) {
      control?.clearValidators();
    }
    control?.updateValueAndValidity();
  }

  toggleValidatorsBasedOnYearly() {
    const control = this.form.get('dayOfYear');
    if (this.isYearly) {
      control?.setValidators(Validators.required);
    } else {
      control?.clearValidators();
    }
    control?.updateValueAndValidity();
  }
// eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSelectionNotificationStatus(event:any){
    this.form.get('ticketScheduleNotificationStatusId')?.setValue(event);
  }
// eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSelectionScheduledStatus(event:any){
    this.form.get('ticketScheduleStatusId')?.setValue(event);
  }

    onDateChange(): void {
    const selectedDate = this.form.get('dayOfYear')?.value;
    this.updateSaveButtonDisabled();
    if (selectedDate) {
      const formatted = moment(selectedDate).format('MMM, D'); // e.g., "Jun, 24"

      // Optional: Store for display or submit elsewhere
      this.formattedDate = formatted;
    }
  }

  convertTimeToDate(timeString: string): Date {
      const [hours, minutes] = timeString.split(':').map(Number);
      const now = new Date(); // Get today's date

      now.setHours(hours, minutes, 0, 0); // Set hours & minutes in UTC

      return now;
  }

  // Helper function to get local date in 24-hour format
  getLocalDate24Hour(): string {

    const localDate = new Date();

    const formattedDate =
      `${localDate.getMonth() + 1}/${localDate.getDate()}/${localDate.getFullYear()} ` +
      `${localDate.getHours().toString().padStart(2,'0')}:` +
      `${localDate.getMinutes().toString().padStart(2,'0')}:` +
      `${localDate.getSeconds().toString().padStart(2,'0')}`;

    return formattedDate;
  }

  async onSubmit() {

        const { scheduleTime, scheduleTimeTo } = this.form.value;
          if (this.form.invalid) return;

          if(this.workingDays.length == 0 && !this.form.get('dayOfMonth').value && this.isWeekly){
            this.notifyService.error({
                      message: 'Please select scheduled On detail.',
                      type: 'Data Error',
                    });
                    this.isSaveButtonDisable = true;
                    return;
          }
          if(!this.form.get('ticketScheduleStartDate').value || !this.form.get('ticketScheduleEndDate').value){
            this.notifyService.error({
                      message: 'Please select scheduled Start and End dates.',
                      type: 'Data Error',
                    });
                    this.isSaveButtonDisable = true;
                    return;
    }
    const scheduleTimeStr = String(scheduleTime ?? '').trim();
    const scheduleTimeToStr = String(scheduleTimeTo ?? '').trim();
    if (!scheduleTimeStr || !scheduleTimeToStr || !scheduleTimeStr.includes(':') || !scheduleTimeToStr.includes(':')) {
      this.notifyService.error({
        message: 'Please select Start Time and End Time.',
        type: 'Data Error',
      });
      this.isSaveButtonDisable = true;
      return;
    }

    if (scheduleTimeToStr <= scheduleTimeStr) {
      this.notifyService.error({
        message: 'End time must be later than start time.',
        type: 'Data Error',
      });
      this.isSaveButtonDisable = true;
      return;
    }
    const [startH, startM] = scheduleTimeStr.split(':').map(Number);
    const [endH, endM] = scheduleTimeToStr.split(':').map(Number);

    const startDate = new Date(this.form.get('ticketScheduleStartDate').value.startDate);
    startDate.setHours(startH, startM, 0, 0);

    const endDate = new Date(this.form.get('ticketScheduleEndDate').value.startDate);
    endDate.setHours(endH, endM, 0, 0);

    const now = new Date();
    // When start date is today, start time must be later than current time
    const isStartDateToday = startDate.toDateString() === now.toDateString();
    if (isStartDateToday && startDate <= now) {
      this.notifyService.error({
        message: 'When start date is today, start time must be later than the current time.',
        type: 'Data validation',
      });
      this.isSaveButtonDisable = true;
      this.loading = false;
      return;
    }
    // When end date is today, end time must be later than current time
    const isEndDateToday = endDate.toDateString() === now.toDateString();
    if (isEndDateToday && endDate <= now) {
      this.notifyService.error({
        message: 'When end date is today, end time must be later than the current time.',
        type: 'Data validation',
      });
      this.isSaveButtonDisable = true;
      this.loading = false;
      return;
    }

    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    if(endDate < startDate){
      this.notifyService.error({
        message: 'The start date must be earlier than the schedule end date.',
        type: 'Data validation',
      });
              this.isSaveButtonDisable = true;
              this.loading = false;

      return
    }
    if(endDate == startDate){
      this.notifyService.error({
        message: 'The schedule start date and end date should not be same.',
        type: 'Data validation',
      });
              this.isSaveButtonDisable = true;

      return
    }

    if(yesterday >= startDate){
      this.notifyService.error({
        message: 'You can not create ticket schedule in past date.',
        type: 'Data validation',
      });
              this.isSaveButtonDisable = true;

      return
    }
    this.loading=true;
    const formData = { ...this.form.value };
    formData.ticketScheduleEndDate = endDate;
    formData.ticketScheduleStartDate = startDate;
    if (this.isYearly) {
      const picked = formData.dayOfYear?.startDate ? new Date(formData.dayOfYear.startDate) : null;
      if (picked) {
        picked.setFullYear(startDate.getFullYear());
        formData.dayOfYear = picked;
      } else {
        formData.dayOfYear = new Date(formData.dayOfYear?.startDate);
      }
    }
    // Convert moment objects to JS Dates
    const schedule = plainToInstance(TicketSchedule, formData);

    const interval = this.form.get('interval').value;
    let lookupSetting;
    if (this.isWeekly) {
      this.workingDays.sort((a, b) => a - b); // mutation is clear
      lookupSetting = `{"Weekly": {"Interval": ${interval}, "DaysOfWeek": [${this.workingDays}]}}`
    }

    else if (this.isMonthly){
      const dayOfMonth = this.form.get('dayOfMonth').value;
      if(!dayOfMonth){
        this.notifyService.error({
        message: 'Please select day of month.',
        type: 'Data validation',
      });

        this.isSaveButtonDisable = true;
        this.loading=false;
      return
      }
      lookupSetting = `{"Monthly": {"Interval": ${interval}, "DayOfMonth": ${dayOfMonth}}}`
    }
    else if(this.isYearly){
      lookupSetting = `{"Yearly": {"Interval": ${interval}, "DayOfYear": "${this.formattedDate }"}}`
    }
    schedule.businessId = this.authService.businessId;
    schedule.ticketScheduleSetting = lookupSetting;

    // Get facility timezone and convert schedule time from facility local to UTC
    let facilityTimeZone: string | undefined;
    try {
      const ticket = await this.ticketService.getTickets(this.selectedTicketId);
      facilityTimeZone = ticket?.facility?.timeZone;
    } catch {
      facilityTimeZone = undefined;
    }

    let ticketTime = this.convertTimeToDate(scheduleTime);

    // now convert to UTC
    const utcDate = this.convertUtcToTimeZone.convertLocalTimeToUTC(ticketTime, facilityTimeZone);
    schedule.ticketScheduleDateTime = utcDate ?? ticketTime;


    schedule.ticketScheduleStartDate =
      this.convertUtcToTimeZone.convertLocalTimeToUTC(startDate, facilityTimeZone);

    schedule.ticketScheduleEndDate =
      this.convertUtcToTimeZone.convertLocalTimeToUTC(endDate, facilityTimeZone);

    schedule.nextOccurrenceDate = null;
    schedule.entryDate = this.getLocalDate24Hour();

    if (this.ticketSchedule?.id) {
      this.service
        .updateTicketSchedule(schedule)
        .then(() => {
          this.notifyService.success({
            message: 'Ticket schedule updated successfully.',
          });
          this.isChangeAnything = false;
          this.dialogRef.close(this.ticketSchedule?.id);
          this.loading=false;
        })
        .catch((error) => {
          this.loading=false;
          error = error.graphQLErrors[0];
          if (error) {
            this.notifyService.error({
              message: error.message,
              type: error.extensions.type,
            });
          } else {
            this.notifyService.error({
              message: 'Failed to update ticket schedule.',
            });
          }
        });

    } else {
      this.service
          .addTicketSchedule(schedule)
          .then(async (id) => {
            this.notifyService.success({
              message: 'Ticket Scheduled successfully.',
            });
            this.loading=false;
            this.dialogRef.close(id);
          })
          .catch((error) => {
            this.loading=false;
            error = error.graphQLErrors[0];
            if (error) {
              this.notifyService.error({
                message: error.message,
                type: error.extensions.type,
              });
            } else {
              this.notifyService.error({
                message: 'Failed to schedule ticket.',
              });
            }
          });
        }
  }

  onChangeDate(){
    this.updateSaveButtonDisabled();
  }
}
